<template>
  <div>
    <div>
      <el-form ref="formSysUser" :model="formSysUser" label-width="75px" label-position="right" @submit.native.prevent>
        <filter-box :item-width="300">
          <el-form-item label="登录名称" prop="formFilter.sysUserLoginName">
            <el-input class="filter-item" v-model="formSysUser.formFilter.sysUserLoginName" :clearable="true"
              placeholder="登录名称" />
          </el-form-item>
          <el-form-item label="登录名称" prop="formFilter.sysUserLoginName">
            <el-input class="filter-item" v-model="formSysUser.formFilter.sysUserLoginName" :clearable="true"
              placeholder="登录名称" />
          </el-form-item>
          <el-button slot="operator" type="default" :plain="true" @click="onReset">重置</el-button>
          <el-button slot="operator" type="primary" :plain="true" @click="refreshFormSysUser(true)">查询</el-button>
        </filter-box>
      </el-form>
    </div>
    <div id="myChart" :style="{ width: '100%', height: '600px' }"></div>
    <div>
      <el-table   header-cell-class-name="table-header-gray">
        <el-table-column label="变更类别" prop="loginName" sortable="custom">
        </el-table-column>
        <el-table-column label="变更次数" prop="showName"> </el-table-column>
        <el-table-column label="累计百分比" prop="email"> </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { findTreeNodePath } from "@/utils";
import { uploadMixin } from "@/core/mixins";

export default {
  props: {
    rowData: Object,
  },
  mixins: [uploadMixin],
  data() {
    return {
      formSysUser: {
        formFilter: {
          sysUserStatus: undefined,
          sysUserLoginName: undefined,
          sysDeptId: undefined,
        },
        formFilterCopy: {
          sysUserStatus: undefined,
          sysUserLoginName: undefined,
          sysDeptId: undefined,
        }
      },
    };
  },
  methods: {
    initData() {
      let myChart = this.$echarts.init(document.getElementById('myChart'));

      var option = {
        xAxis: {
          type: 'category',
          data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            data: [150, 230, 224, 218, 135, 147, 260],
            type: 'line'
          }
        ]
      };
      myChart.setOption(option);
    }
  },
  computed: {
    isEdit() {
      return this.formData.userId != null;
    },
  },
  mounted() {
    this.initData();
  }
};
</script>

<style lang="scss" scoped></style>
